import {
    DEALERADDUPDATEUNIONLIST_FAILED,
    DEALERADDUPDATEUNIONLIST_SUCCESS,
    RESET_DEALERADDUPDATEUNIONLIST,
    LOADING_DEALERADDUPDATEUNIONLIST,
    NETWORK_ERROR_DEALERADDUPDATEUNIONLIST
} from '../types/index';


import { dealerServices } from "../../config/axios";


const resetDealerAddUpdateUnionList = () => {
    return { type: RESET_DEALERADDUPDATEUNIONLIST };
};

const dealerAddUpdateUnionList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDUPDATEUNIONLIST });
    await dealerServices
        .post("unionList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddUpdateUnionListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerAddUpdateUnionListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDUPDATEUNIONLIST,
                payload: err
            });
        });
}

function dealerAddUpdateUnionListsuccess(data) {
    return {
        type: DEALERADDUPDATEUNIONLIST_SUCCESS,
        payload: data
    };
}
function dealerAddUpdateUnionListFailed(data) {
    return {
        type: DEALERADDUPDATEUNIONLIST_FAILED,
        payload: data
    };
}

export { resetDealerAddUpdateUnionList, dealerAddUpdateUnionList }